import {minmax, sectionToFixedMap, portrait, promo} from '../shared.js';
import {buildNarrativeTextTimeline, animateTextHighlights} from '../animations.js';

const article = document.querySelector('#chapter2');

const narrativeSection = article.querySelector('#chapter2-narrative');
const narrativeFixed = sectionToFixedMap.get(narrativeSection);
const narrativeTimeline = new TimelineLite({paused: true});

const narrativeText = narrativeFixed.querySelector('.narrative-text');

const infographicSection = article.querySelector('#chapter2-infographic');
const infographicFixed = sectionToFixedMap.get(infographicSection);
const blackoutCurtain = infographicFixed.querySelector('.blackout-curtain');
const fbi = infographicFixed.querySelector('.fbi');
const cia = infographicFixed.querySelector('.cia');
const fbiConflict = fbi.querySelector('.conflict');
const fbiHighlights = Array.from(fbiConflict.querySelectorAll('.highlight'));
const ciaConflict = cia.querySelector('.conflict');
const ciaHighlights = Array.from(ciaConflict.querySelectorAll('.highlight'));
const lewinsky = document.querySelector('#chapter2-lewinsky');
const lewinskyImage = lewinsky.querySelector('img');
const lewinskyText = lewinsky.querySelector('h2');
const footnote = infographicFixed.querySelector('.footnote');
const infographicTimeline = new TimelineLite({paused: true});
const infographicTimelinePortrait = new TimelineLite({paused: true});

/**
 * Initialize chapter
 */
export function init() {
  console.log('chapter2:init');

  narrativeSection.addEventListener('active', () => promo.classList.add('active'));
  narrativeSection.addEventListener('inactive', () => promo.classList.remove('active'));

  buildNarrativeTextTimeline(narrativeTimeline, narrativeText, 85);

  narrativeSection.addEventListener('scrub', ({detail: {vh}}) => narrativeTimeline.seek(minmax(0, vh, narrativeTimeline.duration())));

  initInfographic();
}

/**
 * Initialize infographic
 */
function initInfographic() {
  TweenLite.set([fbiConflict, ciaConflict, footnote], {opacity: 0});
  TweenLite.set(fbiConflict, {x: '-=25%'});
  TweenLite.set(ciaConflict, {x: '+=25%'});
  TweenLite.set([lewinskyImage, lewinskyText], {opacity: 0});
  TweenLite.set(lewinskyImage, {scale: 1, top: '+=0%'});

  infographicTimeline.to({}, 100, {});

  infographicTimeline.to(blackoutCurtain, 50, {right: '50%'});
  infographicTimeline.to(ciaConflict, 25, {opacity: 1, x: '0%'});

  infographicTimeline.to({}, 25, {});

  animateTextHighlights(ciaHighlights, infographicTimeline);

  infographicTimeline.to({}, 50, {});

  infographicTimeline.to(blackoutCurtain, 50, {right: '0%'});
  infographicTimeline.to(blackoutCurtain, 50, {left: '50%'});
  infographicTimeline.to(fbiConflict, 25, {opacity: 1, x: '0%'});

  infographicTimeline.to({}, 25, {});

  animateTextHighlights(fbiHighlights, infographicTimeline);

  infographicTimeline.to({}, 50, {});

  infographicTimeline.to(blackoutCurtain, 50, {left: '0%'});

  infographicTimeline.to([footnote, lewinskyImage], 25, {opacity: 1});
  infographicTimeline.to(lewinskyImage, 50, {scale: 1.2, top: '+=5%'}, '-=25');
  infographicTimeline.to(lewinskyText, 25, {opacity: 1}, '-=25');

  /* *** MOBILE *** */

  infographicTimelinePortrait.to({}, 100, {});

  infographicTimelinePortrait.set(fbi, {opacity: 0});
  infographicTimelinePortrait.set(cia, {opacity: 1});

  infographicTimelinePortrait.to(blackoutCurtain, 50, {right: '100%'});
  infographicTimelinePortrait.to(ciaConflict, 25, {opacity: 1, x: '0%'});

  infographicTimelinePortrait.to({}, 25, {});

  animateTextHighlights(ciaHighlights, infographicTimelinePortrait);

  infographicTimelinePortrait.to({}, 50, {});

  infographicTimelinePortrait.to(blackoutCurtain, 50, {right: '0%'});

  infographicTimelinePortrait.set(fbi, {opacity: 1});
  infographicTimelinePortrait.set(cia, {opacity: 0});

  infographicTimelinePortrait.to(blackoutCurtain, 50, {left: '100%'});
  infographicTimelinePortrait.to(fbiConflict, 25, {opacity: 1, x: '0%'});

  infographicTimelinePortrait.to({}, 25, {});

  animateTextHighlights(fbiHighlights, infographicTimelinePortrait);

  infographicTimelinePortrait.to({}, 50, {});

  infographicTimelinePortrait.to(blackoutCurtain, 50, {left: '0%'});

  infographicTimelinePortrait.to([footnote, lewinskyImage], 25, {opacity: 1});
  infographicTimelinePortrait.to(lewinskyImage, 50, {scale: 1.2, top: '+=5%'}, '-=25');
  infographicTimelinePortrait.to(lewinskyText, 25, {opacity: 1}, '-=25');

  infographicSection.addEventListener('scrub', ({detail: {vh}}) => {
    if (portrait.matches) {
      infographicTimelinePortrait.seek(minmax(0, vh, infographicTimelinePortrait.duration()), false);
    } else {
      infographicTimeline.seek(minmax(0, vh, infographicTimeline.duration()), false);
    }
  });
}
